<template>
  <b-modal
    size="md"
    id="influencer-edit"
    title="Edit Influencer"
    ok-title="Save"
    @ok="submit"
    @hidden="$emit('hidden')"
    :ok-disabled="isProcessing"
  >
    <div class="form-group row">
      <div class="col-sm-3">
        <label for="name"
          >Influencer Name <span class="text-danger">*</span></label
        >
      </div>
      <div class="col-sm-9">
        <b-form-input v-model="form.name" id="name"></b-form-input>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-3">
        <label for="keywords">Keywords</label>
      </div>
      <div class="col-sm-9">
        <b-form-tags input-id="keywords" v-model="form.keywords"></b-form-tags>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { MediaInfluencerService } from "@/core/services"
import { required } from "vuelidate/lib/validators"
import _ from "lodash"

export default {
  name: "MediaInfluencerCreate",
  props: {
    influencer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: null,
        keywords: [],
      },
      isProcessing: false,
    }
  },
  validations: {
    form: {
      name: { required },
    },
  },
  mounted() {
    this.form = _.cloneDeep(this.influencer)
  },
  methods: {
    async submit(e) {
      e.preventDefault()
      this.isProcessing = true
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.isProcessing = false
        return
      }
      let data = {
        ...this.influencer,
        ...this.form,
      }
      let response = await MediaInfluencerService.update(data)
      if (!response.error) {
        this.$emit("success")
        this.$root.$bvToast.toast("Update influencer success", {
          title: `Success`,
          variant: "success",
          solid: true,
        })
        this.$bvModal.hide("influencer-edit")
      }
      this.isProcessing = false
    },
  },
}
</script>

<style></style>
